import Vue from 'vue';
import {
// PND1
taxGetMonthList,
// PND1
taxExportMonth,
// PND1导出Excel
downloadPdf,
// PND1导出PDF
downloadPNDTxt,
// PND1导出Txt
// PND3
getPnd3MonthList,
// PND3列表
exportPnd3Excel,
// PND3导出Excel
downloadPnd3PDF,
// PND3导出PDF
downloadPnd3TXT,
// PND3导出Txt
// PND1 Kor
getKorLists,
// PND1 Kor列表
exportKorExcel,
// PND1 Kor导出Excel
downloadKorPdf,
// PND1 Kor导出PDF
downloadKorTxt,
// PND1 Kor导出Txt
// SorPorSor1-10
SocialGetMonthList,
// SorPorSor1-10列表
downloadMonthTxt,
// SorPorSor1-10导出Txt
socialExportMonth // SorPorSor1-10导出Excel
// downloadPnd3PDF, // SorPorSor1-10导出PDF
} from 'api/payroll/prove-download';
import { getWelfareFundMonthList } from '@/api/payroll/welfare-fund';
var $t = Vue.prototype.$t;
export var detailData = {
  1: {
    // PND1
    title: $t('certificate_official_4'),
    selectData: {
      pay_month: true,
      // 是否展示该项
      right: true,
      // 右边按钮模块是否展示
      explain: $t('1308'),
      // 说明
      images: {
        zh: require('@/assets/img/Chinese.png'),
        en: require('@/assets/img/en.png'),
        th: require('@/assets/img/th.png')
      },
      txt: $t('1307'),
      // 导出Txt
      pdf: $t('1306'),
      // 导出PDF
      excel: $t('export_excel'),
      // 导出Excel
      text: [$t('certificate_official_15'), $t('certificate_module_13')]
    },
    api: {
      apiList: taxGetMonthList,
      // 获取列表
      apiPdf: downloadPdf,
      // 导出pdf
      apiTxt: downloadPNDTxt,
      // 导出txt
      apiExcel: taxExportMonth // 导出Excel
    },

    picker: {
      label: $t('1744'),
      format: 'yyyy-MM',
      type: 'month'
    },
    query: {
      1: 'month'
    },
    table: [{
      label: $t('205'),
      // 序号
      prop: 'order_number',
      align: '',
      width: '120',
      fixed: false
    }, {
      label: $t('1074'),
      // 公司税号
      prop: 'taxpayer_account',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1075'),
      // 员工税号
      prop: 'id_card_no',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1047'),
      // 称谓
      prop: 'call_type_txt',
      align: '',
      width: '144',
      fixed: false
    }, {
      label: $t('1048'),
      // 名
      prop: 'first_name',
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('1049'),
      // 姓
      prop: 'last_name',
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('1073'),
      // 收入类型编号
      prop: 'income_code',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1076'),
      // 支付日期
      prop: 'pay_date',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1077'),
      // 应发金额
      prop: 'all_income',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1088'),
      // 税额
      prop: 'salary_month_tax',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1335'),
      // 扣税条件
      prop: 'conditions',
      align: '',
      width: '192',
      fixed: false
    }]
  },
  2: {
    // PND3
    title: $t('certificate_official_6'),
    selectData: {
      pay_month: true,
      // 是否展示该项
      right: true,
      // 右边按钮模块是否展示
      explain: false,
      // 说明
      txt: $t('1307'),
      // 导出Txt
      pdf: $t('1306'),
      // 导出PDF
      excel: $t('export_excel'),
      // 导出Excel
      text: [$t('certificate_official_17'), $t('certificate_module_20')]
    },
    api: {
      apiList: getPnd3MonthList,
      // 获取列表
      apiPdf: downloadPnd3PDF,
      // 导出pdf
      apiTxt: downloadPnd3TXT,
      // 导出txt
      apiExcel: exportPnd3Excel // 导出Excel
    },

    picker: {
      label: $t('1744'),
      format: 'yyyy-MM',
      type: 'month'
    },
    query: {
      1: 'month'
    },
    table: [{
      label: $t('205'),
      // 序号
      prop: 'order_number',
      align: '',
      width: '120',
      row: true,
      fixed: false
    }, {
      label: $t('1074'),
      // 公司税号
      prop: 'taxpayer_account',
      align: '',
      width: '168',
      row: true,
      fixed: false
    }, {
      label: $t('1075'),
      // 员工税号
      prop: 'id_card_no',
      align: '',
      width: '168',
      row: true,
      fixed: false
    }, {
      label: $t('1240'),
      // 分支机构编号
      prop: 'branch_no',
      align: '',
      width: '168',
      row: true,
      fixed: false
    }, {
      label: $t('1047'),
      // 称谓
      prop: 'call_type_txt',
      align: '',
      width: '144',
      row: true,
      fixed: false
    }, {
      label: $t('1048'),
      // 名
      prop: 'first_name',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1049'),
      // 姓
      prop: 'last_name',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_2c22fe9d'),
      // 村庄
      prop: 'village',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1245'),
      // 门牌号
      prop: 'door_number',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1246'),
      // 村号
      prop: 'village_no',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_f2c22fe9'),
      // 巷
      prop: 'lane',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1247'),
      // 街道
      prop: 'road',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_ff2c22fe'),
      // 乡
      prop: 'district',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_8ff2c22f'),
      // 市
      prop: 'city',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_c22fe9dc'),
      // 省
      prop: 'province',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1042'),
      // 邮编
      prop: 'postal_code',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1076'),
      // 支付日期
      prop: 'pay_date',
      align: '',
      width: '168',
      row: true,
      fixed: false
    }, {
      label: $t('1980'),
      // 收入类型
      prop: 'income_type',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('645'),
      // 税率
      prop: 'tax_rate',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1077'),
      // 应发金额
      prop: 'all_income',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1088'),
      // 税额
      prop: 'salary_month_tax',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1335'),
      // 扣税条件
      prop: 'conditions',
      align: '',
      width: '192',
      fixed: false
    }]
  },
  3: {
    // PND1 Kor
    title: $t('certificate_official_8'),
    selectData: {
      pay_month: true,
      // 是否展示该项
      right: true,
      // 右边按钮模块是否展示
      explain: false,
      // 说明
      txt: $t('1307'),
      // 导出Txt
      pdf: $t('1306'),
      // 导出PDF
      excel: $t('export_excel'),
      // 导出Excel
      text: [$t('certificate_official_16'), $t('certificate_module_18'), $t('certificate_module_19')]
    },
    api: {
      apiList: getKorLists,
      // 获取列表
      apiPdf: downloadKorPdf,
      // 导出pdf
      apiTxt: downloadKorTxt,
      // 导出txt
      apiExcel: exportKorExcel // 导出Excel
    },

    picker: {
      label: $t('837'),
      options: true,
      // 限制年份选择今年以前的，不包括今年
      format: 'yyyy',
      type: 'year'
    },
    query: {
      1: 'year'
    },
    table: [{
      label: $t('205'),
      // 序号
      prop: 'order_number',
      align: '',
      width: '120',
      fixed: false
    }, {
      label: $t('1074'),
      // 公司税号
      prop: 'taxpayer_account',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1075'),
      // 员工税号
      prop: 'id_card_no',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1047'),
      // 称谓
      prop: 'call_type_txt',
      align: '',
      width: '144',
      fixed: false
    }, {
      label: $t('1048'),
      // 名
      prop: 'first_name',
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('1049'),
      // 姓
      prop: 'last_name',
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('15366_2c22fe9d'),
      // 村庄
      prop: 'village',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1245'),
      // 门牌号
      prop: 'door_number',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1246'),
      // 村号
      prop: 'village_no',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_f2c22fe9'),
      // 巷
      prop: 'lane',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1247'),
      // 街道
      prop: 'road',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_ff2c22fe'),
      // 乡
      prop: 'district',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_8ff2c22f'),
      // 市
      prop: 'city',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('15366_c22fe9dc'),
      // 省
      prop: 'province',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1042'),
      // 邮编
      prop: 'postal_code',
      align: '',
      width: '216',
      row: true,
      fixed: false
    }, {
      label: $t('1076'),
      // 支付日期
      prop: 'pay_date',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1980'),
      // 收入类型
      prop: 'income_code',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1077'),
      // 应发金额
      prop: 'all_income',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1088'),
      // 税额
      prop: 'salary_year_tax',
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('1335'),
      // 扣税条件
      prop: 'conditions',
      align: '',
      width: '192',
      fixed: false
    }]
  },
  4: {
    // SorPorSor1-10
    title: $t('certificate_official_10'),
    selectData: {
      pay_month: true,
      // 是否展示该项
      right: true,
      // 右边按钮模块是否展示
      explain: false,
      // 说明
      txt: $t('1307'),
      // 导出Txt
      pdf: false,
      // 导出PDF
      excel: $t('export_excel'),
      // 导出Excel
      text: [$t('certificate_official_18'), $t('certificate_module_21')]
    },
    api: {
      apiList: SocialGetMonthList,
      // 获取列表
      apiTxt: downloadMonthTxt,
      // 导出txt
      apiExcel: socialExportMonth // 导出Excel
    },

    picker: {
      label: $t('1744'),
      format: 'yyyy-MM',
      type: 'month'
    },
    query: {
      1: 'month'
    },
    table: [{
      label: $t('passport_no'),
      prop: 'id_card_no',
      // 身份证号
      align: '',
      width: '180',
      fixed: false
    }, {
      label: $t('1047'),
      prop: 'call_type_txt',
      // 称谓
      align: '',
      width: '144',
      fixed: false
    }, {
      label: $t('1048'),
      prop: 'first_name',
      // 名
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('1049'),
      prop: 'last_name',
      // 姓
      align: '',
      width: '216',
      fixed: false
    }, {
      label: $t('1072'),
      prop: 'all_income',
      // 薪酬
      align: '',
      width: '192',
      fixed: false
    }, {
      label: $t('i18n.xqTd045nDIt3'),
      prop: 'social_income',
      // 社保金额
      align: '',
      width: '192',
      fixed: false
    }]
  },
  5: {
    // SorKorLor 3
    title: $t('24916_f7b526d8'),
    selectData: {
      text: [$t('24916_d853328b')]
    },
    api: {
      apiList: getWelfareFundMonthList
    },
    query: {
      1: 'month'
    },
    table: [{
      label: $t('1047'),
      // 称谓
      prop: 'call_type_txt',
      align: '',
      width: '144',
      fixed: false
    }, {
      label: $t('1048'),
      // 名字
      prop: 'first_name',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('1049'),
      // 姓氏
      prop: 'last_name',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('age'),
      // 年龄
      prop: 'age',
      align: '',
      width: '120',
      fixed: false
    }, {
      label: $t('1051'),
      // 国籍
      prop: 'nationality_txt',
      align: '',
      width: '144',
      fixed: false
    }, {
      label: $t('1053'),
      // 身份证号/护照号
      prop: 'id_card_no',
      align: '',
      width: '180',
      fixed: false
    }, {
      label: $t('24916_68c70a10'),
      // 雇佣类型
      prop: 'employment_type',
      align: '',
      width: '180',
      fixed: false
    }, {
      label: $t('24916_f287f7b5'),
      // 福利基金基数
      prop: 'wage',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('28'),
      // 入职日期
      prop: 'hire_date',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('29'),
      // 离职日期
      prop: 'leave_date',
      align: '',
      width: '168',
      fixed: false
    }, {
      label: $t('24916_07042921'),
      // 离职原因和备注
      prop: 'leave_reason',
      align: '',
      width: '168',
      fixed: false
    }]
  }
};